/**
 *
 * ContentContainer.js
 *
 * A container wrapper to have a limited width on large screens
 */
import React from 'react';
import PropTypes from 'prop-types';

function ContentContainer(props) {
    let cn = 'container';

    if (props.className) {
        cn += ` ${props.className}`;
    }
    return <div className={cn}>{props.children}</div>;
}

ContentContainer.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};

export default ContentContainer;
